import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class SalesOrders_ds_get_non_elligible_for_allocation_inventory_by_lotId_packagingId_locationId_warehouseIdService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { lotId: number, packagingId: number, warehouseId: number, locationId: number }): 
  Promise<{ result: { TotalNonAllocatablePackagedAmount?: number, LotId?: number, PackagedId?: number, LocationId?: number, Location?: { WarehouseId?: number } } }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.lotId)) {
      $missingRequiredInParams.push('\'lotId\'');
    }
    if (isNil($inParams.packagingId)) {
      $missingRequiredInParams.push('\'packagingId\'');
    }
    if (isNil($inParams.warehouseId)) {
      $missingRequiredInParams.push('\'warehouseId\'');
    }
    if (isNil($inParams.locationId)) {
      $missingRequiredInParams.push('\'locationId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      lotId: number, packagingId: number, warehouseId: number, locationId: number    }) {
        if(isNil($inParams.lotId)) {
          return true; 
        }
        if(isNil($inParams.packagingId)) {
          return true; 
        }
        if(isNil($inParams.warehouseId)) {
          return true; 
        }
        if(isNil($inParams.locationId)) {
          return true; 
        }
      return false;
    }
}
